/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */
import Util from '@/util';


const today = new Date().toISOString().substr(0, 10);

const theState = {
    loading: false,
    errorMessage: '',
    stores: [],
    plainOffers: [],
    selectedStore: null,
    selectedOffer: null,
    validFrom: today,
    validFromFormatted: Util.toDate(today),
    validTo: null,
    validToFormatted: null,
    ssoId: null,
};

const getters = {
    offers(state) {
        const now = new Date().getTime();
        return state.plainOffers
            .filter(offer => offer.stores.length && offer.stores.every((store) => {
                const validFrom = new Date(store.valid_from).getTime();
                const validTo = new Date(store.valid_to).getTime();
                return store.store_id === state.selectedStore
                    && validFrom <= now
                    && now <= validTo
                    && store.contained_products.every(product => product.product_id.indexOf('print') === -1);
            })).map(offer => ({
                name: offer.name,
                description: offer.description,
                offerId: offer.offer_id,
            }));
    },

    hasError(state) {
        return state.errorMessage.length > 0;
    },
};

const actions = {
    loadStores({ commit }) {
        commit('setLoading', true);
        Api.adHocPurchase.stores()
            .then(({ data }) => {
                commit('setStores', data.data);
                commit('setErrorMessage', '');
            })
            .catch(() => {
                commit('setStores', []);
                commit('setErrorMessage', 'Beim Laden der Stores ist ein Fehler aufgetreten.');
            })
            .finally(() => {
                commit('setLoading', false);
            });
    },

    loadOffers({ commit }, store) {
        commit('setLoading', true);
        commit('setSelectedStore', store);
        commit('setOffers', []);
        commit('setSelectedOffer', null);
        commit('setValidFrom', new Date().toISOString().substr(0, 10));
        commit('setValidTo', null);
        Api.adHocPurchase.offers(store)
            .then(({ data }) => {
                commit('setOffers', data.data);
                commit('setErrorMessage', '');
            })
            .catch(() => {
                commit('setErrorMessage', 'Beim Laden der Offers ist ein Fehler aufgetreten.');
            })
            .finally(() => {
                commit('setLoading', false);
            });
    },

    commitPurchase({ commit, state }, ssoId) {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            const {
                validFrom,
                validTo,
                selectedOffer,
                selectedStore,
            } = state;

            const from = new Date(validFrom);
            const to = new Date(validTo);
            to.setDate(to.getDate() + 1);

            Api.adHocPurchase.commit({
                ssoId,
                storeId: selectedStore,
                offerId: selectedOffer.offerId,
                validFrom: from.getTime() - (-from.getTimezoneOffset() * 1000 * 60),
                validTo: to.getTime() - 1000 - (-to.getTimezoneOffset() * 1000 * 60),
            }).then(() => {
                resolve('Sofortfreigabe erfolgreich erstellt.');
            }).catch(() => {
                reject(new Error('Fehler beim Erstellen der Sofortfreigabe.'));
            }).finally(() => {
                commit('setLoading', false);
            });
        });
    },
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },

    setStores(state, stores) {
        state.stores = stores;
    },

    setOffers(state, offers) {
        state.plainOffers = offers;
    },

    setSelectedStore(state, selectedStore) {
        state.selectedStore = selectedStore;
    },

    setSelectedOffer(state, selectedOffer) {
        state.selectedOffer = selectedOffer;
    },

    setValidFrom(state, validFrom) {
        state.validFrom = validFrom;
        state.validFromFormatted = Util.toDate(validFrom);
    },

    setValidTo(state, validTo) {
        state.validTo = validTo;
        state.validToFormatted = Util.toDate(validTo);
    },

    setErrorMessage(state, message) {
        state.errorMessage = message;
    },

    resetState(state) {
        state.loading = false;
        state.errorMessage = '';
        state.stores = [];
        state.plainOffers = [];
        state.selectedStore = null;
        state.selectedOffer = null;
        state.validFrom = new Date().toISOString().substr(0, 10);
        state.validTo = null;
        state.ssoId = null;
    },
};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
